import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAdminList,
  type IGetAdminListResponse
} from '../../../api/accountApi';
import { getErrorData, type IErrorData } from '../../../utils/getErrorData';
import { isError } from '../../../utils/typeguards/isError';
import { hasResponse } from '@/utils/typeguards/hasResponse';

/**
 * Thunk для получения списка админов
 */
export const getAdminsListThunk = createAsyncThunk<
  IGetAdminListResponse,
  undefined,
  { rejectValue: IErrorData | undefined }
>('managersList/getAdminsList', async (_, { rejectWithValue }) => {
  try {
    const data = await getAdminList({ account_role: 'ROLE_MANAGER' });

    if (isError(data)) {
      return rejectWithValue(data);
    }

    if (!hasResponse<IGetAdminListResponse>(data)) {
      return rejectWithValue({ message: 'Некорректный ответ сервера' });
    }

    return data.response;
  } catch (error) {
    const extractedError = getErrorData(error);
    return rejectWithValue(extractedError);
  }
});
